<template>
    <ag-grid-vue
        ref="agGrid"
      style="width: 100%; height: 40vh; min-height: 200px"
      :class="{'ag-theme-balham' : !this.$vuetify.theme.dark,
              'ag-theme-balham-dark' : this.$vuetify.theme.dark }"
      :gridOptions="gridOptions"

      :enableColResize="true"
      :enableSorting="true"

      :defaultColDef="defaultColDef"
      :columnDefs="columnDefines"
      :frameworkComponents="gridOptions.frameworkComponents"

      :context="context"
      :rowData="attendList"

      rowSelection="multiple"
      @grid-ready="onGridReady"
      @first-data-rendered="onFirstDataRendered"
      @row-data-updated="onRowDataUpdated"
      @cellClicked="onClickRow"
  />
</template>

<script>
import {AgGridVue} from 'ag-grid-vue'
import {
  btnRendererAttend, btnRendererNoClass, btnRendererNoShow, btnRendererPostpone, btnRendererTeacherError
} from "@/components/Grid/GridAttendButtonRenderer";
import apiAttend from "@/api/modules/api-attend";
import {mapGetters} from "vuex";
import util_device from "@/utils/util_device";
import {cellRendererAttendStatus} from "@/components/Grid/GridCellRenderer";
import {agGridDatePicker} from "@/utils/agGrid_util";

export default {
  name: 'GridAttend',
  components: {AgGridVue,
    btnRendererAttend, btnRendererNoClass, btnRendererNoShow, btnRendererPostpone, btnRendererTeacherError,
    cellRendererAttendStatus
  },
  props: {
    attendList: Array,
    columnDefines: {type: Array, default: () =>
          [
            // {flex: 0.5,   valueGetter: "node.rowIndex + 1"},
            {flex: 0.8,   colId: 'assignId'            , headerName: 'Assign Id',             field: 'assignId', },
            {flex: 0.8,   colId: 'attendId'            , headerName: 'Attend Id',                    field: 'attendId' },
            {flex: 1.2,   colId: 'attendDate'          , headerName: 'Date',           field: 'attendDate', editable: true, cellEditor: agGridDatePicker},
            {flex: 0.5,   colId: 'attendDay'           , headerName: 'Day',           field: 'attendDay'},
            {flex: 0.8,   colId: 'courseName'          , headerName: 'Course',                field: 'courseName'},
            {flex: 1,     colId: 'contentName'         , headerName: 'Content',               field: 'contentName'},
            {flex: 1,     colId: 'studentName'         , headerName: 'Student Korean',        field: 'studentName'},
            // {flex: 1,     colId: 'student.englishName' , headerName: 'Student Name',          field: 'student.englishName'},
            {flex: 0.8,   colId: 'teacherName'         , headerName: 'Teacher Name',             field: 'teacherName'},
            {flex: 1,     colId: 'attendStatus'        , headerName: 'Status',               field: 'attendStatus', cellRenderer: 'cellRendererAttendStatus'},
            {flex: 1,     colId: 'feedback'            , headerName: 'Feedback(press Enter)', field: 'feedback', editable: true, cellEditor: 'agLargeTextCellEditor', cellEditorPopup: true, cellStyle: {'background-color': 'grey'} },
            
            {flex: 1,   colId: 'btnAttend'         , headerName: 'Student Attend',                field: 'btnAttend', cellRendererFramework: "btnRendererAttend" },
            {flex: 1,   colId: 'btnNoClass'         , headerName: 'No Class',              field: 'btnNoClass', cellRendererFramework: "btnRendererNoClass" },
            {flex: 1,   colId: 'btnNoShow'         , headerName: 'Student NoShow',               field: 'btnNoShow', cellRendererFramework: "btnRendererNoShow" },
            {flex: 1,   colId: 'btnPostpone'         , headerName: 'Student Postpone',              field: 'btnPostpone', cellRendererFramework: "btnRendererPostpone" },
            {flex: 1,   colId: 'btnTeacherAbsent'     , headerName: 'Teacher Absent',           field: 'btnTeacherAbsent', cellRendererFramework: "btnRendererTeacherError" },
    ]},
    isShowButton: Boolean,
    isDialog: Boolean
  },
  data() {
    return {
      listLoading: true,
      context: '',
      columnApi: null,
      gridApi: [],
      gridOptions: {
        animateRows: false,
        frameworkComponents: {},
        rowHeight: 40
      },
      defaultColDef: {
        sortable: true,
        flex: 8,
        wrapText: true,
        filter: true,
        resizable: true
      },
      overlay: false
    }
  },
  watch : {
    attendList: function (){
      // this.$refs.agGrid.rowData = this.attendList
    },
    overlay (val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 2000)
    },
  },
  computed: {
    ...mapGetters(['app', 'user', 'isManager', 'isTeacher']),
  },
  created() { },
  mounted() {
    window.addEventListener('resize', this.hideActionColumn);
  },
  methods: {
    onGridReady(params){
      params.api.setHeaderHeight(60);
      this.columnApi = params.columnApi;
      this.gridApi = params.api;
      this.$emit('onGridReady', this.gridApi, this.gridOptions)
      this.hideActionColumn()
    },
    onFirstDataRendered(params){
      if (params.lastRow > 0){
        const index = this.attendList.findIndex(v => v.attendDate === this.$formatDate(new Date(), 'YYYY-MM-DD'))

        this.gridOptions.api.getRowNode(index).setSelected(true)
        this.gridOptions.api.ensureIndexVisible(index)
      }
      this.$emit('onFirstDataRendered', params)
    },
    onRowDataUpdated(event){ this.$emit('onRowDataUpdated', event) },
    isChangable(row) {
      let date10daysAgo = new Date(new Date().setDate(new Date().getDate() - 10))
      let nowDateTime = new Date()
      let tomorrowDate = new Date(new Date().setDate(new Date().getDate() + 1))

      let isBeforeClass = row.attendStartTime > (this.$parseDate(nowDateTime, '{y}-{m}-{d}') + 'T' + (nowDateTime.getHours() + 1) + ':' + nowDateTime.getMinutes())
      let isBetweenPeriod = (row.attendDate > this.$parseDate(date10daysAgo, '{y}-{m}-{d}')
                              && row.attendDate < this.$parseDate(tomorrowDate, '{y}-{m}-{d}'))

      if (isBeforeClass || isBetweenPeriod || this.isManager)
        return true;
      else
        return false;
    },
    noClassToday(row){
      row.attendStatus = 'NOCLASS'
      row.attendFlag = ''
      row.studentFlag = ''
      row.teacherFlag = ''
      this.updateAttend(row)
    },
    attendToday(row){
      row.attendStatus = row.attendStatus !== 'ATTEND' ? 'ATTEND' : 'NOCLASS'
      row.attendFlag = 'Y'
      this.updateAttend(row)
    },
    postponeToday(row){
      if (!this.isChangable(row) && row.attendStatus !== 'NOCLASS') {
        this.$dialog.notify.error('변경이 불가능한 상태입니다. 관리자에게 문의해주세요. ',{position: 'top-right', timeout: 1500})
        return
      }
      row.attendStatus = row.attendStatus === 'POSTPONE' ? 'NOCLASS' : 'POSTPONE'
      this.updateAttend(row)
    },
    noShowToday(row){
      if (!this.isChangable(row)) {
        this.$dialog.notify.error('변경이 불가능한 상태입니다. 관리자에게 문의해주세요. ',{position: 'top-right', timeout: 1500})
        return
      }
      if(row.attendStatus !=='NOCLASS') return
      row.attendStatus = row.attendStatus !== 'NOSHOW' ? 'NOSHOW' : 'NOCLASS'
      row.attendFlag = 'Y'
      this.updateAttend(row)
    },
    teacherAbsent(row){
      if (!this.isChangable(row)) {
        this.$dialog.notify.error('변경이 불가능한 상태입니다. 관리자에게 문의해주세요. ',{position: 'top-right', timeout: 1500})
        return
      }
      row.attendStatus = row.attendStatus !== 'TEACHER_IMPOSSIBLE' ? 'TEACHER_IMPOSSIBLE' : 'NOCLASS'
      this.updateAttend(row)
    },
    updateAttend(row) {
      apiAttend.postAttend(row)
          .then(res => {
            const index = this.attendList.findIndex(v => v.attendDate === res.attendDate && v.assignId === res.assignId)
            this.attendList.splice(index, 1, res)
            return index
          })
          .then(index => {
            this.gridOptions.api.ensureIndexVisible(index + 2)
            this.gridOptions.api.getRowNode(index).setSelected(true)
          })
          .then(() => this.$dialog.notify.info('Success', {position: 'top-right',timeout: 3000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },
    onClickRow(params) {
      let row = params.data
      let colId = params.column.getId();
      switch (colId) {
        case "btnAttend":  this.attendToday(row); break;
        case "btnNoClass":  this.noClassToday(row); break;
        case "btnNoShow": this.noShowToday(row); break;
        case "btnPostpone":  this.postponeToday(row); break;
        case "btnTeacherAbsent": this.teacherAbsent(row); break;
      }
    },
    hideActionColumn() {
      let deviceType = util_device.getDeviceType()
      let isMobile = (['tablet','mobile']).includes(deviceType)
      if(this.columnApi) {
        // this.columnApi.setColumnVisible('id', !isMobile)
        // this.columnApi.setColumnVisible('attendId', !isMobile)
        this.columnApi.setColumnVisible('callType', !isMobile)
        this.columnApi.setColumnVisible('classStartTime', !isMobile)
        this.columnApi.setColumnVisible('contentName', !isMobile)
        this.columnApi.setColumnVisible('courseName', !isMobile)
        this.columnApi.setColumnVisible('teacherName', !isMobile)
        this.columnApi.setColumnVisible('attendFlag', !isMobile)
      }

      if(this.isDialog){
        this.columnApi.setColumnVisible('attendId', !this.isDialog)
        this.columnApi.setColumnVisible('assignId', !this.isDialog)
        this.columnApi.setColumnVisible('callType', !this.isDialog)
        this.columnApi.setColumnVisible('courseName', !this.isDialog)
        this.columnApi.setColumnVisible('contentName', !this.isDialog)
        this.columnApi.setColumnVisible('studentName', !this.isDialog)
        this.columnApi.setColumnVisible('student.englishName', !this.isDialog)
        this.columnApi.setColumnVisible('teacherName', !this.isDialog)
        this.columnApi.setColumnVisible('feedback', !this.isDialog)
      }

      this.columnApi.setColumnVisible('btnAttend', this.isShowButton )
      this.columnApi.setColumnVisible('btnNoClass', this.isShowButton )
      this.columnApi.setColumnVisible('btnNoShow', this.isShowButton )
      this.columnApi.setColumnVisible('btnTeacherAbsent', this.isShowButton )
    },
  }
}
</script>